import { useOutletContext } from "react-router-dom";
import { useEffect } from 'react';
import { Link } from "react-router-dom";
import { PAGE_TITLE_BASE, PageDisplayNames, PageNames } from '../Assets/variables';
import Images from '../Assets/Images/images';
import { Helmet } from "react-helmet-async";

const Home = () => {
    const {sidebarToggler, setActivePageItem} = useOutletContext();

    useEffect(() => {
        sidebarToggler(false);
        setActivePageItem(PageNames.Home);
    }, []);

    return (
        <>
            <Helmet>
                <title>{`${PAGE_TITLE_BASE}${PageDisplayNames.Home}`}</title>
                <meta name="description" content={`${PageDisplayNames.Home} page of the SIX Web API Portal`} />
                <link rel="canonical" href={`/${PageNames.Home}`} />
            </Helmet>
            <div class="home">
                <section class="first-container">
                    <div class="section-inner">
                        <div class="left-side">
                            <h1>Financial Data APIs</h1>
                            <p><strong>Seamless access to the SIX Financial Data universe. </strong></p>
                            <p>Developed with established data standards, they leverage modern web technologies to ensure easy integration, fast processing, and cost efficiency.</p>
                            <Link class="button button--big" to={`/${PageNames.Catalog}`}>Discover the API catalog</Link>
                        </div>
                        <div class="right-side">
                            <img src={Images.HomePageImage} alt="SIX API" />
                        </div>
                    </div>
                </section>
        
                <section class="second-container">
                    <div class="section-inner">
                        <div class="left-side">
                            <h2>SIX Web API</h2>
                            <p><strong>The SIX Web API is designed to empower web applications, internal platforms, and public websites.</strong> It utilizes REST/JSON for request-response data retrieval, WebSockets for real-time market data streaming, and GraphQL to let users effortlessly pick and choose the content they need. With global coverage and easy integration, it is the ideal solution for dynamic and data-driven applications.</p>
                        </div>
                        <div class="right-side">
                            <h2>SIX Bulk API</h2>
                            <p><strong>The SIX Bulk API is designed to seamlessly feed security master and databases. </strong>With speed and scalability at its core, it can update your database with millions of instruments within minutes, not hours. Leveraging REST/JSON technology, it ensures rapid initial loading and delta updates whenever you want, keeping your database current and responsive without compromising performance.</p>
                        </div>
                    </div>
                </section>
                
                <section class="third-container">
                    <div class="section-inner">
                        <div class="cards">
                            <h2>Standard Identifiers</h2>
                            <p>
                                The SIX API supports a variety of instrument identifiers, including ISIN, CUSIP, WKN, SEDOL, FIGI, tickers, and others. This removes the need to convert portfolios to proprietary identifiers.
                            </p>
                        </div>
                        <div class="cards">
                            <h2>Standard Data Format</h2>
                            <p>
                                The SIX API also applies ISO standards for currencies, country codes, and timestamps. Easy to understand and consume whilst retaining high standards of quality and accuracy. 
                            </p>
                        </div>
                        <div class="cards">
                            <h2>The SIX Financial Data Universe</h2>
                            <p>
                                900+ multi-asset price sources through a single API overlayed with complimentary data sets that include reference data, corporate actions, regulatory, tax, ESG and more.
                            </p>
                        </div>
                    </div>
                </section>
        
                <section class="fourth-container">
                    <div class="section-inner">
                        <div class="contact-us">
                            <h3>Any Questions? We are happy to help</h3>
                            <a class="button button--small" href="https://www.six-group.com/en/products-services/financial-information/display-and-delivery-capabilities/six-api/demo.html" target="_blank">Get in touch</a>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default Home;